// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_ReleaseInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Release request body — frees a reservation that produced no billable output.
 *
 * Posted by the agent on its two pre-stream failure paths (unexpected loop throw
 * and `result.releaseBilling`). Without it the reserve hold stays on the wallet
 * forever and the franchise walks into a permanent 402.
 *
 * Required fields:
 *   franquia_id  (int)    — billing franchise (payer-validated against user permissions)
 *   request_id   (string) — idempotency key; MUST be the same key used for reserve
 *
 * No amount field: app-api sizes the release from the ORIGINAL reserve ledger row,
 * so the agent can never release more than it held.
 */
import { registerContract } from './validate'

export interface AiCredits_ReleaseInput {
franquia_id: number
request_id: string
}

registerContract('AiCredits_ReleaseInput', {
  franquia_id: { type: 'number',  required: true },
  request_id:  { type: 'string',  required: true },
})
